import Vue from "vue";
import Router from "vue-router";
import home from "@/components/home";
import courseDetail from "@/components/detail";
import choose from "@/components/choose";
import notice from "@/components/notice";
import message from "@/components/messageList";
import about from "@/components/about";
import feedback from "@/components/feedback";
import privacypolicy from "@/components/privacypolicy";
import useragreement from "@/components/useragreement";
import live from "@/components/live";
import examination from "@/components/examination";
import history from "@/components/history";
import newslist from "@/components/newslist";
import newsdetail from "@/components/newsdetail";
import teacheranswers from "@/components/teacheranswers";
import questiondetail from "@/components/questiondetail";
import training from "@/components/training";
import submitquestion from "@/components/submitquestion";
import myteacheranswers from "@/components/myteacheranswers";
import errorcollect from "@/components/errorcollect";
import buy from "@/components/buy";
import pay from "@/components/pay";
import dotest from "@/components/dotest";
import homework from "@/components/homework";
import examsdetail from "@/components/examsdetail";
import examsresult from "@/components/examsresult";
import noticelist from "@/components/noticelist";
import homeworklist from "@/components/homeworklist";
import highfrequency from "@/components/highfrequency";
import doubles from "@/components/double";
import beforeexamination from "@/components/beforeexamination";
import onlinetest from "@/components/onlinetest";
import analysis from "@/components/analysis";
import viewAnswer from "@/components/viewAnswer";
import concat from "@/components/concat";
import homenewsdetail from "@/components/homenewsdetail";
import homenewslist from "@/components/homenewslist";
import productlist from "@/components/productlist";
import piclist from "@/components/piclist";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

export default new Router({
  //  mode:'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
      meta: {
        title: "培仕通"
      }
    },
    {
      path: "/courseDetail",
      name: "courseDetail",
      component: courseDetail,
      meta: {
        title: "课程详情"
      }
    },
    {
      path: "/productlist",
      name: "productlist",
      component: productlist,
      meta: {
        title: "精品课程"
      }
    },
    {
      path: "/homenewsdetail",
      name: "homenewsdetail",
      component: homenewsdetail,
      meta: {
        title: "新闻详情"
      }
    },
    {
      path: "/homenewslist",
      name: "homenewslist",
      component: homenewslist,
      meta: {
        title: "新闻列表"
      }
    },
    {
      path: "/piclist",
      name: "piclist",
      component: piclist,
      meta: {
        title: "图集"
      }
    },
    {
      path: "/choose",
      name: "choose",
      component: choose,
      meta: {
        title: "选择考试"
      }
    },
    {
      path: "/notice",
      name: "notice",
      component: notice,
      meta: {
        title: "公告"
      }
    },
    {
      path: "/message",
      name: "message",
      component: message,
      meta: {
        title: "系统通知"
      }
    },
    {
      path: "/about",
      name: "about",
      component: about,
      meta: {
        title: "关于我们"
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: feedback,
      meta: {
        title: "意见反馈"
      }
    },
    {
      path: "/privacypolicy",
      name: "privacypolicy",
      component: privacypolicy,
      meta: {
        title: "隐私政策"
      }
    },
    {
      path: "/useragreement",
      name: "useragreement",
      component: useragreement,
      meta: {
        title: "用户协议"
      }
    },
    {
      path: "/live",
      name: "live",
      component: live,
      meta: {
        title: "免费直播"
      }
    },
    {
      path: "/examination",
      name: "examination",
      component: examination,
      meta: {
        title: "模拟考试"
      }
    },
    {
      path: "/history",
      name: "history",
      component: history,
      meta: {
        title: "历年考题"
      }
    },
    {
      path: "/newslist",
      name: "newslist",
      component: newslist,
      meta: {
        title: "新闻中心"
      }
    },
    {
      path: "/newsdetail",
      name: "newsdetail",
      component: newsdetail,
      meta: {
        title: "新闻详情"
      }
    },
    {
      path: "/teacheranswers",
      name: "teacheranswers",
      component: teacheranswers,
      meta: {
        title: "老师答疑"
      }
    },
    {
      path: "/questiondetail",
      name: "questiondetail",
      component: questiondetail,
      meta: {
        title: "答疑详情"
      }
    },
    {
      path: "/training",
      name: "training",
      component: training,
      meta: {
        title: "阶段测试"
      }
    },
    {
      path: "/submitquestion",
      name: "submitquestion",
      component: submitquestion,
      meta: {
        title: "提交答疑"
      }
    },
    {
      path: "/myteacheranswers",
      name: "myteacheranswers",
      component: myteacheranswers,
      meta: {
        title: "我的答疑"
      }
    },
    {
      path: "/errorcollect",
      name: "errorcollect",
      component: errorcollect,
      meta: {
        title: "错题收藏"
      }
    },
    {
      path: "/buy",
      name: "buy",
      component: buy,
      meta: {
        title: "购买服务"
      }
    },
    {
      path: "/pay",
      name: "pay",
      component: pay,
      meta: {
        title: "老师答疑"
      }
    },
    {
      path: "/dotest",
      name: "dotest",
      component: dotest,
      meta: {
        title: "测试中心"
      }
    },
    {
      path: "/homework",
      name: "homework",
      component: homework,
      meta: {
        title: "章节练习"
      }
    },
    {
      path: "/examsdetail",
      name: "examsdetail",
      component: examsdetail,
      meta: {
        title: "习题详情"
      }
    },
    {
      path: "/examsresult",
      name: "examsresult",
      component: examsresult,
      meta: {
        title: "考试介绍"
      }
    },
    {
      path: "/noticelist",
      name: "noticelist",
      component: noticelist,
      meta: {
        title: "通知列表"
      }
    },
    {
      path: "/homeworklist",
      name: "homeworklist",
      component: homeworklist,
      meta: {
        title: "章节练习"
      }
    },
    {
      path: "/highfrequency",
      name: "highfrequency",
      component: highfrequency,
      meta: {
        title: "高频考点"
      }
    },
    {
      path: "/double",
      name: "double",
      component: doubles,
      meta: {
        title: "二二密训"
      }
    },
    {
      path: "/beforeexamination",
      name: "beforeexamination",
      component: beforeexamination,
      meta: {
        title: "考前押题"
      }
    },
    {
      path: "/onlinetest",
      name: "onlinetest",
      component: onlinetest,
      meta: {
        title: "在线答题"
      }
    },
    {
      path: "/analysis",
      name: "analysis",
      component: analysis,
      meta: {
        title: "答案解析"
      }
    },
    {
      path: "/viewAnswer",
      name: "viewAnswer",
      component: viewAnswer,
      meta: {
        title: "答案解析"
      }
    },
    {
      path: "/concat",
      name: "concat",
      component: concat,
      meta: {
        title: "联系我们"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js